<div class="fixed inset-0 bg-gray-700 bg-opacity-75 flex justify-center items-center z-20">
    <div class="bg-white shadow-lg rounded p-4 max-w-md w-full relative">
        <form [formGroup]="pageForm" (ngSubmit)="submit()">
            <h1 class="font-bold text-xl">{{title}}</h1>
            <p class="mt-1 text-primary-300 text-sm">{{description}}</p>
            @if(pageForm.errors) {
            <div class="mt-2 w-full bg-red-200 border-l-2 border-l-red-500">
                <p class="text-primary-500 text-xs px-2 py-1">{{pageForm.errors | json}}</p>
            </div>
            }
            <div class="mt-2 w-full">
                <label class="text-xs w-full mb-1" for="lessonName">Lesson Name *</label>
                <input type="text" name="lessonName" id="lessonName" formControlName="lessonName"
                    placeholder="Lesson Name"
                    class="rounded w-full my-auto outline-none ring-0 focus:outline-none focus:ring-0">
                <div
                    class="{{ pageForm.get('lessonName')?.invalid && (pageForm.get('lessonName')?.dirty || pageForm.get('lessonName')?.touched) ? 'visible' : 'invisible'}}  pt-1 h-3 text-red-500 text-xs">
                    @if (pageForm.get('lessonName')?.errors?.['required']) {
                    <p>
                        Value is required
                    </p>
                    } @else if(pageForm.get('lessonName')?.errors?.['minlength'] ||
                    pageForm.get('lessonName')?.errors?.['maxlength']) {
                    <p>
                        Min 3 and max 100 characters required
                    </p>
                    }
                </div>
            </div>

            <div class="mt-2 w-full">
                <label class="text-xs w-full mb-1" for="publishBy">Visible On</label>
                <input type="datetime-local" name="publishBy" id="publishBy" formControlName="publishBy" [min]="minTime"
                    class="rounded w-full my-auto outline-none ring-0 focus:outline-none focus:ring-0">
            </div>

            <div class="flex flex-row gap-4 justify-end mt-4">
                <button type="button" (click)="onCancel()"
                    class="text-primary-500 px-4 py-2 focus:outline-none">Cancel</button>
                <app-btn-submit [isDisabled]="pageForm.invalid || ((loading$ | async) ?? false)"
                    [isLoading]="((loading$ | async) ?? false)" [actionText]="action"
                    icon="fa fa-save"></app-btn-submit>
            </div>
        </form>
    </div>
</div>